import React, { useState, useEffect } from "react";
import { Bed, Clear, FilterList, Hotel, MeetingRoomOutlined, NightShelter, PriceCheckOutlined, RoomOutlined, Search, SingleBed, Tune, Close, VerifiedOutlined, DirectionsWalkOutlined } from "@mui/icons-material"
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Button, IconButton, TextField, Box, Typography, Chip, Paper, Grid, Fade, Zoom,
    CircularProgress, Drawer, Divider, Collapse
} from "@mui/material"
import Select from 'react-select';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./../Utils/styles.css"
import { allcampuses } from "../Utils/arrays";
import axios from "axios";
import { Fetchhousesurl, Searchhousesurl, Updateclicks, Updatelikes } from "../Utils/urls";
import { FaAngleLeft, FaAngleRight, FaMapMarkerAlt, FaRegMap, FaHeart, FaSlidersH } from "react-icons/fa";
import Shuffle from "../Utils/shuffle";
import { getrecentlyviewed, getsessionuser, setrecentlyviewedhouses } from "../Utils/sessions";
import Hireagentmodal from "./hireagentmodal";
import { gottowhatsapp } from "../Utils/functions";

const BRAND = '#900f20';
const BRAND_DARK = '#670600';
const GOLD = '#b8863b';

// ─── Filter options ────────────────────────────────────────────────────────
const typeOptions = [
    { label: "Single Room", value: "Single room" },
    { label: "Bedsitter", value: "Bedsitter" },
    { label: "1 Bedroom", value: "1 Bedroom" },
    { label: "2 Bedroom", value: "2 Bedroom" },
    { label: "3 Bedroom", value: "3 Bedroom" },
    { label: "Apartment", value: "Appartment" },
];
const priceOptions = [
    { label: "Ksh 1,000 – 5,000", value: "1000-5000" },
    { label: "Ksh 6,000 – 10,000", value: "6000-10000" },
    { label: "Ksh 11,000 – 15,000", value: "11000-15000" },
    { label: "Ksh 16,000 – 20,000", value: "16000-20000" },
    { label: "Ksh 21,000 – 25,000", value: "21000-25000" },
    { label: "Ksh 26,000 – 30,000", value: "26000-30000" },
    { label: "Ksh 31,000 – 35,000", value: "31000-35000" },
    { label: "Ksh 36,000 – 40,000", value: "36000-40000" },
    { label: "Ksh 40,000+", value: "40000-100000" },
];
const audienceOptions = [
    { label: "All", value: "all" },
    { label: "Students", value: "students" },
    { label: "Non-students", value: "non-students" },
];

// ─── Quick filter pill buttons ──────────────────────────────────────────────
const CategoryButton = ({ label, icon, onClick, active }) => (
    <Button
        onClick={onClick}
        startIcon={icon}
        sx={{
            borderRadius: '24px', px: 2.5, py: 0.9, textTransform: 'none', fontWeight: 600, fontSize: '0.88rem',
            backgroundColor: active ? 'rgba(144, 15, 32, 0.1)' : 'white',
            color: active ? BRAND : 'text.secondary',
            border: `1px solid ${active ? BRAND : '#e0e0e0'}`,
            boxShadow: active ? '0 4px 12px rgba(144, 15, 32, 0.1)' : '0 2px 8px rgba(0,0,0,0.02)',
            transition: 'all 0.3s ease',
            '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 6px 16px rgba(0,0,0,0.08)', borderColor: BRAND, color: BRAND, bgcolor: active ? 'rgba(144,15,32,0.12)' : 'white' }
        }}
    >
        {label}
    </Button>
);

// ─── Property Card (modernized) ─────────────────────────────────────────────
const PropertyCard = ({ val, user, latitude, longitude, onLike, onNavigate }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [liked, setLiked] = useState(false);

    const images = [val.profilepic_url, val.pic1_url, val.pic2_url, val.pic3_url, val.pic4_url, val.pic5_url, val.pic6_url].filter(Boolean);

    const handleNextImage = (e) => { e.stopPropagation(); setCurrentImageIndex((p) => (p + 1) % images.length); };
    const handlePrevImage = (e) => { e.stopPropagation(); setCurrentImageIndex((p) => (p === 0 ? images.length - 1 : p - 1)); };

    function calcCrow(lat1, lon1, lat2, lon2) {
        const R = 6371;
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) ** 2;
        return Math.round(R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    }

    const distanceKm = (latitude && longitude) ? calcCrow(val?.latitude, val?.longitude, latitude, longitude) : null;
    // Walking-pace estimate (~5km/h) — tells a student "how long", not just "how far"
    const walkMinutes = distanceKm !== null && !isNaN(distanceKm) ? Math.max(1, Math.round(distanceKm * 12)) : null;
    const isCloseWalk = walkMinutes !== null && walkMinutes <= 15;

    const priceFormatted = parseInt(val?.price || 0).toLocaleString();

    return (
        <Paper
            elevation={0}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => { setIsHovered(false); setCurrentImageIndex(0); }}
            onClick={() => onNavigate(val)}
            sx={{
                width: { xs: '100%', sm: '48%', md: '31%', lg: '18.4%' },
                mb: 3, borderRadius: '18px', overflow: 'hidden', cursor: 'pointer',
                border: '1px solid rgba(0,0,0,0.06)', bgcolor: 'white',
                transition: 'all 0.3s cubic-bezier(0.2, 0.8, 0.2, 1)',
                boxShadow: isHovered ? '0 16px 32px rgba(0,0,0,0.10)' : 'none',
                transform: isHovered ? 'translateY(-4px)' : 'none',
                display: 'flex', flexDirection: 'column'
            }}
        >
            {/* Image */}
            <Box sx={{ position: 'relative', height: 200, overflow: 'hidden', bgcolor: '#f0eeec' }}>
                <Box
                    component="img"
                    src={images[currentImageIndex]}
                    alt={val?.housename}
                    loading="lazy"
                    decoding="async"
                    sx={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease', transform: isHovered ? 'scale(1.05)' : 'scale(1)' }}
                />
                {/* Gradient keeps price legible over any photo */}
                <Box sx={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(0,0,0,0.25) 0%, rgba(0,0,0,0) 30%, rgba(0,0,0,0) 60%, rgba(0,0,0,0.4) 100%)', pointerEvents: 'none' }} />

                <Box sx={{ position: 'absolute', top: 12, left: 12, display: 'flex', gap: 0.75 }}>
                    <Chip label={val?.type} size="small"
                        sx={{ bgcolor: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(4px)', fontWeight: 700, fontSize: '0.72rem', height: 24 }}
                    />
                    {val?.status === 'Approved' && (
                        <Chip icon={<VerifiedOutlined sx={{ fontSize: '14px !important', color: `${GOLD} !important` }} />} label="Verified" size="small"
                            sx={{ bgcolor: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(4px)', fontWeight: 700, fontSize: '0.7rem', height: 24, color: GOLD }}
                        />
                    )}
                </Box>

                <IconButton
                    onClick={(e) => { e.stopPropagation(); setLiked(v => !v); onLike(val.id); }}
                    size="small" aria-label="Save property"
                    sx={{ position: 'absolute', top: 10, right: 10, bgcolor: 'rgba(255,255,255,0.92)', backdropFilter: 'blur(4px)', '&:hover': { bgcolor: 'white' } }}
                >
                    <FaHeart size={14} color={liked ? BRAND : "#a4b0be"} />
                </IconButton>

                <Typography sx={{
                    position: 'absolute', bottom: 10, left: 14, color: 'white', fontWeight: 800,
                    fontSize: '1.15rem', lineHeight: 1, textShadow: '0 2px 8px rgba(0,0,0,0.35)'
                }}>
                    {val?.currency} {priceFormatted}
                    <Typography component="span" sx={{ fontSize: '0.72rem', fontWeight: 500, ml: 0.5, opacity: 0.85 }}>/ sem</Typography>
                </Typography>

                {isHovered && images.length > 1 && (
                    <>
                        <Box onClick={handlePrevImage} sx={{ position: 'absolute', top: '50%', left: 8, transform: 'translateY(-50%)', width: 28, height: 28, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.92)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 2 }}>
                            <FaAngleLeft size={12} color="#2f3542" />
                        </Box>
                        <Box onClick={handleNextImage} sx={{ position: 'absolute', top: '50%', right: 8, transform: 'translateY(-50%)', width: 28, height: 28, borderRadius: '50%', bgcolor: 'rgba(255,255,255,0.92)', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 2 }}>
                            <FaAngleRight size={12} color="#2f3542" />
                        </Box>
                        <Box sx={{ position: 'absolute', bottom: 42, left: 0, right: 0, display: 'flex', justifyContent: 'center', gap: 0.5, zIndex: 2 }}>
                            {images.map((_, i) => (
                                <Box key={i} sx={{ width: i === currentImageIndex ? 14 : 5, height: 5, borderRadius: 3, bgcolor: i === currentImageIndex ? 'white' : 'rgba(255,255,255,0.5)', transition: 'all 0.3s' }} />
                            ))}
                        </Box>
                    </>
                )}
            </Box>

            {/* Content */}
            <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '0.98rem', color: '#2d3436', mb: 0.6, display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                    {val?.housename}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary', mb: 1.25 }}>
                    <RoomOutlined sx={{ fontSize: 15, mr: 0.6, color: '#a4b0be' }} />
                    <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '0.82rem' }}>{val?.location}</Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 'auto', pt: 1.25, borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                    {walkMinutes !== null ? (
                        <Box sx={{
                            display: 'inline-flex', alignItems: 'center', gap: 0.5,
                            bgcolor: isCloseWalk ? 'rgba(184,134,59,0.12)' : 'rgba(0,0,0,0.04)',
                            color: isCloseWalk ? GOLD : 'text.disabled',
                            borderRadius: '100px', px: 1, py: 0.35,
                        }}>
                            <DirectionsWalkOutlined sx={{ fontSize: 14 }} />
                            <Typography sx={{ fontSize: '0.7rem', fontWeight: 700 }}>
                                {walkMinutes <= 20 ? `${walkMinutes} min walk` : `${distanceKm}km away`}
                            </Typography>
                        </Box>
                    ) : (
                        <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <FaMapMarkerAlt size={11} /> Location unavailable
                        </Typography>
                    )}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.3, color: BRAND, opacity: isHovered ? 1 : 0, transition: 'opacity 0.2s' }}>
                        <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '0.7rem' }}>
                            View &rarr;
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Paper>
    );
};

// ─── Main Component ─────────────────────────────────────────────────────────
const Allhostels = () => {
    const [hint, sethint] = useState('');
    const [campusfilter, setcampusfilter] = useState('Chuka University\tChuka');
    const [typefilter, settypefilter] = useState('');
    const [pricefilter, setpricefilter] = useState('');
    const [audiencefilter, setaudiencefilter] = useState('all');
    const [filterDrawerOpen, setfilterDrawerOpen] = useState(false);
    const [activeFiltersCount, setactiveFiltersCount] = useState(0);

    const user = getsessionuser();
    const navigate = useNavigate();
    const temprecentlyviewed = getrecentlyviewed();

    const [progress, setprogress] = useState(true);
    const [display, setdisplay] = useState(false);
    const [error, seterror] = useState('');
    const [houses, sethouses] = useState([]);
    const [longitude, setlongitude] = useState('');
    const [latitude, setlatitude] = useState('');
    const [recentlyviewed, setrecentlyviewed] = useState(temprecentlyviewed || []);
    const [showpopup, setshowpopup] = useState(false);

    const [sortedhouses, setsortedhouses] = useState([]);
    const [sortedfirstslot, setsortedfirstslot] = useState([]);
    const [sortedsecondslot, setsortedsecondslot] = useState([]);
    const [sortedthirdslot, setsortedthirdslot] = useState([]);
    const [sortedfourthslot, setsortedfourthslot] = useState([]);
    const [activeSlotId, setactiveSlotId] = useState(1);

    useEffect(() => {
        fetchall();
        getlocation();
        checkpopup();
    }, []);

    // Recount active filters
    useEffect(() => {
        let count = 0;
        if (typefilter) count++;
        if (pricefilter) count++;
        if (audiencefilter && audiencefilter !== 'all') count++;
        setactiveFiltersCount(count);
    }, [typefilter, pricefilter, audiencefilter]);

    const checkpopup = () => {
        const todaypopupstatus = { status: true, date: new Date().toLocaleDateString() };
        const temppopupobject = localStorage?.getItem("popupstatus");
        if (temppopupobject) {
            const { status, date } = JSON.parse(temppopupobject);
            if (status && date !== new Date().toLocaleDateString()) {
                setshowpopup(true);
                localStorage.setItem("popupstatus", JSON.stringify(todaypopupstatus));
            }
        } else {
            setshowpopup(true);
            localStorage.setItem("popupstatus", JSON.stringify(todaypopupstatus));
        }
    };

    const getlocation = () => {
        navigator.geolocation.getCurrentPosition(
            (pos) => { setlatitude(pos.coords.latitude); setlongitude(pos.coords.longitude); },
            () => { } // silently fail
        );
    };

    const updateclick = (id) => axios.post(Updateclicks, { id }).catch(() => { });
    const updatelikes = (id) => axios.post(Updatelikes, { id }).catch(() => { });

    const chunkAndSet = (formatted) => {
        const perChunk = Math.max(1, Math.round(formatted.length / 4));
        const result = formatted.reduce((acc, item, idx) => {
            const chunkIdx = Math.floor(idx / perChunk);
            if (!acc[chunkIdx]) acc[chunkIdx] = [];
            acc[chunkIdx].push(item);
            return acc;
        }, []);
        setsortedfirstslot(result[0] || []);
        setsortedsecondslot(result[1] || []);
        setsortedthirdslot(result[2] || []);
        setsortedfourthslot(result[3] || []);
        setsortedhouses(result[0] || []);
        setactiveSlotId(1);
    };

    const fetchall = () => {
        sethint('');
        setprogress(true);
        setdisplay(false);
        seterror(null);
        axios.post(Fetchhousesurl, { campus: campusfilter }).then(response => {
            setprogress(false);
            if (!response.data.message) {
                document.title = 'Eazistey Hostels';
                document.querySelector('meta[name="description"]')?.setAttribute('content', response.data?.map(v => v.housename).join(', '));
                setdisplay(true);
                const approved = response.data.filter(o => o.status === 'Approved');
                const unapproved = response.data.filter(o => o.status === 'Unapproved');
                Shuffle(approved);
                const formatted = [...approved, ...unapproved];
                sethouses(formatted);
                chunkAndSet(formatted);
            } else {
                seterror(response.data.message);
            }
        }).catch(() => {
            setprogress(false);
            seterror("Sorry there was an error. Try again later.");
        });
    };

    // Unified search+filter — called any time a filter changes
    const applyFilters = ({ hint: h, campus: cam, type: typ, price: pri, audience: aud } = {}) => {
        const searchHint = h !== undefined ? h : hint;
        const campus = cam !== undefined ? cam : campusfilter;
        const type = typ !== undefined ? typ : typefilter;
        const price = pri !== undefined ? pri : pricefilter;
        const audience = aud !== undefined ? aud : audiencefilter;

        setdisplay(false);
        seterror(null);

        axios.post(Fetchhousesurl, {
            hint: searchHint,
            plowerrange: price ? price.split('-')[0] : '',
            phigherrange: price ? price.split('-')[1] : '',
            type: type || '',
            campus: campus || '',
        }).then(response => {
            setprogress(false);
            if (!response.data.message) {
                setdisplay(true);
                if (Array.isArray(response.data) && response.data.length > 0) {
                    const approved = response.data.filter(o => o.status === 'Approved');
                    const unapproved = response.data.filter(o => o.status === 'Unapproved');
                    Shuffle(approved);
                    let formatted = [...approved, ...unapproved];
                    // Apply audience filter client-side
                    if (audience && audience !== 'all') {
                        formatted = formatted.filter(o => o.category === audience);
                    }
                    sethouses(formatted);
                    if (searchHint || type || price) {
                        // When filtering, show all results without pagination split
                        setsortedhouses(formatted);
                        setsortedfirstslot(formatted);
                        setsortedsecondslot([]);
                        setsortedthirdslot([]);
                        setsortedfourthslot([]);
                        setactiveSlotId(1);
                    } else {
                        chunkAndSet(formatted);
                    }
                } else {
                    seterror("No properties match your search.");
                }
            } else {
                seterror(response.data.message);
            }
        }).catch(() => {
            setprogress(false);
            seterror("Sorry there was an error. Try again later.");
        });
    };

    const savehousetorecentlyviewed = (house) => {
        const list = [...recentlyviewed];
        const idx = list.findIndex(o => o?.id === house.id);
        if (idx > -1) list.splice(idx, 1);
        list.unshift(house);
        const tostore = list.slice(0, 4);
        setrecentlyviewed(tostore);
        setrecentlyviewedhouses(tostore);
    };

    const handleNavigate = (val) => {
        savehousetorecentlyviewed(val);
        if (user?.username === val?.username) {
            navigate(`/nav/viewsingleproperty/${val.id}`);
        } else {
            updateclick(val.id);
            navigate(`/nav/viewsinglehouse/${val.id}`);
        }
    };

    const clearAllFilters = () => {
        settypefilter('');
        setpricefilter('');
        setaudiencefilter('all');
        sethint('');
        fetchall();
    };

    const paginationSlots = [
        { id: 1, data: sortedfirstslot },
        { id: 2, data: sortedsecondslot },
        { id: 3, data: sortedthirdslot },
        { id: 4, data: sortedfourthslot },
    ].filter(s => s.data && s.data.length > 0);

    // Custom react-select style to match premium theme
    const selectStyles = {
        control: (base, state) => ({
            ...base, borderRadius: 12, border: `1px solid ${state.isFocused ? BRAND : '#e0e0e0'}`, boxShadow: state.isFocused ? `0 0 0 2px rgba(144,15,32,0.1)` : 'none', '&:hover': { borderColor: BRAND }, minHeight: 44, fontSize: 14,
        }),
        option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? BRAND : state.isFocused ? 'rgba(144,15,32,0.05)' : 'white', color: state.isSelected ? 'white' : '#2d3436', fontWeight: state.isSelected ? 700 : 400 }),
        indicatorSeparator: () => ({ display: 'none' }),
    };

    return (
        <Box sx={{ bgcolor: '#f8f9fa', minHeight: '100vh', pb: 12, width: "95%", margin: "auto" }}>
            {showpopup && <Hireagentmodal ondismiss={() => setshowpopup(false)} />}

            {/* ── Filter Drawer ── */}
            <Drawer anchor="right" open={filterDrawerOpen} onClose={() => setfilterDrawerOpen(false)}
                PaperProps={{ sx: { width: { xs: '100%', sm: 380 }, borderRadius: '24px 0 0 24px', p: 3 } }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                    <Typography variant="h6" sx={{ fontWeight: 800 }}>Filters</Typography>
                    <IconButton onClick={() => setfilterDrawerOpen(false)}><Close /></IconButton>
                </Box>
                <Divider sx={{ mb: 3 }} />
                <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: 'text.disabled', mb: 1, display: 'block' }}>Audience</Typography>
                <Select styles={selectStyles} options={audienceOptions} defaultValue={audienceOptions[0]} onChange={e => { setaudiencefilter(e.value); applyFilters({ audience: e.value }); }} isSearchable={false} />
                <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: 'text.disabled', mt: 3, mb: 1, display: 'block' }}>Campus</Typography>
                <Select styles={selectStyles} options={allcampuses} onChange={e => { setcampusfilter(e.value); applyFilters({ campus: e.value }); }} placeholder="Select campus..." />
                <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: 'text.disabled', mt: 3, mb: 1, display: 'block' }}>Room Type</Typography>
                <Select styles={selectStyles} options={typeOptions} onChange={e => { settypefilter(e.value); applyFilters({ type: e.value }); }} placeholder="Select room type..." />
                <Typography variant="caption" sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1px', color: 'text.disabled', mt: 3, mb: 1, display: 'block' }}>Budget</Typography>
                <Select styles={selectStyles} options={priceOptions} onChange={e => { setpricefilter(e.value); applyFilters({ price: e.value }); }} placeholder="Select budget range..." />
                <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
                    <Button
                        fullWidth variant="outlined"
                        onClick={() => { clearAllFilters(); setfilterDrawerOpen(false); }}
                        sx={{ borderRadius: '14px', textTransform: 'none', fontWeight: 700, borderColor: 'rgba(0,0,0,0.12)', color: 'text.secondary', py: 1.5 }}
                    >
                        Clear All
                    </Button>
                    <Button
                        fullWidth variant="contained" disableElevation
                        onClick={() => setfilterDrawerOpen(false)}
                        sx={{ borderRadius: '14px', textTransform: 'none', fontWeight: 700, py: 1.5, background: `linear-gradient(90deg, ${BRAND} 0%, ${BRAND_DARK} 100%)` }}
                    >
                        Apply
                    </Button>
                </Box>
            </Drawer>

            {/* ── Header ── */}
            <Box sx={{ px: { xs: 2, md: 4 }, pt: 4, pb: 2 }}>
                <Typography variant="h4" sx={{ fontWeight: 800, color: '#1a1a1a', letterSpacing: '-0.5px', mb: 0.75 }}>
                    Find Your Perfect Eazihome
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4, maxWidth: 600 }}>
                    Discover premium verified student lodgings near your campus.
                </Typography>

                {/* Quick type filters */}
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', mb: 3 }}>
                    <CategoryButton label="Single Room" icon={<NightShelter fontSize="small" />}
                        onClick={() => { const v = 'Single room'; settypefilter(v === typefilter ? '' : v); applyFilters({ type: v === typefilter ? '' : v }); }}
                        active={typefilter === 'Single room'} />
                    <CategoryButton label="Bedsitter" icon={<Hotel fontSize="small" />}
                        onClick={() => { const v = 'Bedsitter'; settypefilter(v === typefilter ? '' : v); applyFilters({ type: v === typefilter ? '' : v }); }}
                        active={typefilter === 'Bedsitter'} />
                    <CategoryButton label="1 Bedroom" icon={<SingleBed fontSize="small" />}
                        onClick={() => { const v = '1 Bedroom'; settypefilter(v === typefilter ? '' : v); applyFilters({ type: v === typefilter ? '' : v }); }}
                        active={typefilter === '1 Bedroom'} />
                    <CategoryButton label="2 Bedroom" icon={<Bed fontSize="small" />}
                        onClick={() => { const v = '2 Bedroom'; settypefilter(v === typefilter ? '' : v); applyFilters({ type: v === typefilter ? '' : v }); }}
                        active={typefilter === '2 Bedroom'} />
                </Box>

                {/* Search Bar */}
                <Box sx={{ display: 'flex', gap: 1.5, width: { xs: '100%', md: '75%', lg: '60%' } }}>
                    <Paper elevation={0} sx={{ display: 'flex', alignItems: 'center', pl: 2, flex: 1, borderRadius: '16px', bgcolor: 'white', boxShadow: '0 8px 32px rgba(0,0,0,0.04)', border: '1px solid rgba(0,0,0,0.03)' }}>
                        <Search sx={{ color: 'text.disabled', mr: 1, flexShrink: 0 }} />
                        <TextField
                            fullWidth placeholder="Search by name, location, or amenities..."
                            variant="standard" InputProps={{ disableUnderline: true }}
                            value={hint}
                            onChange={(e) => { sethint(e.target.value); applyFilters({ hint: e.target.value }); }}
                            onKeyDown={(e) => e.key === 'Enter' && applyFilters()}
                            sx={{ flex: 1 }}
                        />
                        {hint && (
                            <IconButton size="small" onClick={() => { sethint(''); applyFilters({ hint: '' }); }} sx={{ mr: 1 }}>
                                <Clear fontSize="small" />
                            </IconButton>
                        )}
                    </Paper>

                    {/* Filter Button */}
                    <Box sx={{ position: 'relative' }}>
                        <IconButton
                            onClick={() => setfilterDrawerOpen(true)}
                            sx={{
                                height: '100%', px: 2.5, borderRadius: '16px', bgcolor: 'white',
                                boxShadow: '0 8px 32px rgba(0,0,0,0.04)', border: `1px solid ${activeFiltersCount > 0 ? BRAND : 'rgba(0,0,0,0.03)'}`,
                                '&:hover': { bgcolor: 'white', boxShadow: '0 8px 32px rgba(0,0,0,0.06)' }
                            }}
                        >
                            <FaSlidersH size={18} color={activeFiltersCount > 0 ? BRAND : '#888'} />
                            {activeFiltersCount > 0 && (
                                <Box sx={{ position: 'absolute', top: 6, right: 6, width: 18, height: 18, borderRadius: '50%', bgcolor: BRAND, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography sx={{ color: 'white', fontSize: '0.65rem', fontWeight: 800 }}>{activeFiltersCount}</Typography>
                                </Box>
                            )}
                        </IconButton>
                    </Box>
                </Box>

                {/* Active filter chips */}
                {activeFiltersCount > 0 && (
                    <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                        <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 600 }}>Active filters:</Typography>
                        {typefilter && (
                            <Chip size="small" label={typefilter} onDelete={() => { settypefilter(''); applyFilters({ type: '' }); }}
                                sx={{ bgcolor: 'rgba(144,15,32,0.08)', color: BRAND, fontWeight: 600, '& .MuiChip-deleteIcon': { color: BRAND } }} />
                        )}
                        {pricefilter && (
                            <Chip size="small" label={priceOptions.find(p => p.value === pricefilter)?.label || pricefilter} onDelete={() => { setpricefilter(''); applyFilters({ price: '' }); }}
                                sx={{ bgcolor: 'rgba(144,15,32,0.08)', color: BRAND, fontWeight: 600, '& .MuiChip-deleteIcon': { color: BRAND } }} />
                        )}
                        {audiencefilter && audiencefilter !== 'all' && (
                            <Chip size="small" label={audiencefilter} onDelete={() => { setaudiencefilter('all'); applyFilters({ audience: 'all' }); }}
                                sx={{ bgcolor: 'rgba(144,15,32,0.08)', color: BRAND, fontWeight: 600, '& .MuiChip-deleteIcon': { color: BRAND } }} />
                        )}
                        <Chip size="small" label="Clear all" onClick={clearAllFilters}
                            sx={{ bgcolor: 'rgba(0,0,0,0.04)', fontWeight: 600, cursor: 'pointer' }} />
                    </Box>
                )}
            </Box>

            {/* ── Main Content ── */}
            <Box sx={{ px: { xs: 2, md: 4 }, mt: 2 }}>
                {/* Error */}
                {error && (
                    <Fade in>
                        <Box sx={{ bgcolor: 'error.light', color: 'error.main', p: 2, borderRadius: '12px', mb: 3, display: 'inline-block' }}>
                            <Typography variant="body2" fontWeight={600}>{error}</Typography>
                        </Box>
                    </Fade>
                )}

                {/* Loading Skeletons */}
                {progress && (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: '2%' } }}>
                        {[...Array(8)].map((_, i) => (
                            <Paper key={i} elevation={0} sx={{ width: { xs: '100%', sm: '48%', md: '31%', lg: '18.4%' }, height: 320, borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'rgba(0,0,0,0.02)' }}>
                                <CircularProgress size={28} sx={{ color: BRAND }} />
                            </Paper>
                        ))}
                    </Box>
                )}

                {/* Results */}
                {display && sortedhouses.length > 0 && (
                    <Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                            <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                                {sortedhouses.length} {sortedhouses.length === 1 ? 'property' : 'properties'} found
                            </Typography>
                        </Box>

                        {/* Property Grid — only the active pagination slot is ever rendered/mounted;
                            keyed by val.id so switching pages doesn't reuse/mutate an existing card's
                            DOM node (which was forcing full image reloads and reading as "slow"). */}
                        <Fade in={true} key={activeSlotId} timeout={300}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: '2%' } }}>
                                {sortedhouses.map((val) => (
                                    <PropertyCard key={val.id} val={val} user={user} latitude={latitude} longitude={longitude} onLike={updatelikes} onNavigate={handleNavigate} />
                                ))}
                            </Box>
                        </Fade>

                        {/* Agent Banner */}
                        <Paper elevation={0} onClick={gottowhatsapp}
                            sx={{ mt: 4, mb: 4, p: 3, borderRadius: '16px', background: 'linear-gradient(135deg, rgba(144,15,32,0.04) 0%, rgba(103,6,0,0.04) 100%)', border: '1px solid rgba(144,15,32,0.08)', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', transition: 'all 0.3s', '&:hover': { background: 'rgba(144,15,32,0.07)', transform: 'translateY(-2px)' } }}
                        >
                            <Box>
                                <Typography variant="h6" sx={{ color: BRAND, fontWeight: 800, mb: 0.5 }}>Can't find what you're looking for?</Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>Hire a verified field agent to find the perfect hostel for you.</Typography>
                            </Box>
                            <Button variant="outlined" sx={{ mt: { xs: 2, sm: 0 }, borderColor: BRAND, color: BRAND, borderRadius: '12px', textTransform: 'none', fontWeight: 700, '&:hover': { bgcolor: 'rgba(144,15,32,0.04)', borderColor: BRAND } }}>
                                Contact Agent
                            </Button>
                        </Paper>

                        {/* Pagination */}
                        {paginationSlots.length > 1 && (
                            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 6 }}>
                                <Paper elevation={0} sx={{ display: 'inline-flex', p: 0.75, borderRadius: '24px', bgcolor: 'white', border: '1px solid rgba(0,0,0,0.06)', boxShadow: '0 4px 12px rgba(0,0,0,0.02)' }}>
                                    {paginationSlots.map((slot) => {
                                        const active = activeSlotId === slot.id;
                                        return (
                                            <Box key={slot.id} onClick={() => { setsortedhouses(slot.data); setactiveSlotId(slot.id); }}
                                                sx={{
                                                    width: 40, height: 40, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                    cursor: 'pointer', mx: 0.5, transition: 'all 0.3s',
                                                    bgcolor: active ? BRAND : 'transparent',
                                                    color: active ? 'white' : 'text.secondary',
                                                    fontWeight: active ? 700 : 500,
                                                    '&:hover': { bgcolor: active ? BRAND : 'rgba(144,15,32,0.08)', color: active ? 'white' : BRAND }
                                                }}
                                            >
                                                {slot.id}
                                            </Box>
                                        );
                                    })}
                                </Paper>
                            </Box>
                        )}
                    </Box>
                )}

                {/* Recently Viewed */}
                {display && recentlyviewed.length > 0 && (
                    <Box sx={{ mt: 6, pt: 4, borderTop: '1px solid rgba(0,0,0,0.06)' }}>
                        <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a1a1a', mb: 3 }}>Recently Viewed</Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: { xs: 2, sm: '2%' } }}>
                            {recentlyviewed.map((val) => (
                                <PropertyCard key={val.id} val={val} user={user} latitude={latitude} longitude={longitude} onLike={updatelikes} onNavigate={handleNavigate} />
                            ))}
                        </Box>
                    </Box>
                )}
            </Box>

            {/* ── Floating Map Button ── */}
            <Zoom in style={{ transitionDelay: '500ms' }}>
                <Box
                    onClick={() => houses.length > 0 && navigate('/nav/viewallmarkers', { state: { houses, longitude: houses[0]?.longitude, latitude: houses[0]?.latitude } })}
                    sx={{
                        position: 'fixed', bottom: 36, left: '50%', transform: 'translateX(-50%)',
                        bgcolor: '#1a1a1a', color: 'white', px: 4, py: 1.8, borderRadius: '30px',
                        display: 'flex', alignItems: 'center', gap: 1.5,
                        cursor: 'pointer', boxShadow: '0 12px 32px rgba(0,0,0,0.2)', zIndex: 1000,
                        fontWeight: 700, letterSpacing: '0.5px',
                        transition: 'all 0.3s ease',
                        '&:hover': { bgcolor: '#000', transform: 'translateX(-50%) translateY(-4px)', boxShadow: '0 16px 40px rgba(0,0,0,0.3)' }
                    }}
                >
                    View Map <FaRegMap size={18} />
                </Box>
            </Zoom>
        </Box>
    );
};

export default Allhostels;